// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"e5388e39","879":"3b0e68e5"}[chunkId] + ".chunk.js";
};